import {
  Completion
} from "./chunk-Y2SYHILB.mjs";
import {
  __async
} from "./chunk-WNQUEZJF.mjs";

// src/providers/install-id/install-id-provider.ts
function installIdProvider() {
  return __async(this, null, function* () {
    if (window.yvaDatastore) {
      try {
        const endpoint = `https://installations.youversionapi${window.yvaDatastore.config.environment === "production" ? "" : "staging"}.com/3.1/install`;
        const installResponse = yield fetch(endpoint, {
          body: JSON.stringify({}),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          method: "POST"
        });
        const responseJson = yield installResponse.json();
        Completion.App.fire({
          completionContext: "installation",
          screenId: null,
          success: true
        });
        return responseJson.id;
      } catch (error) {
        if (window.yvaDatastore.config.debug) {
          console.error("Error fetching install id");
          console.dir(error, { depth: null });
        }
      }
    }
  });
}

export {
  installIdProvider
};
